import { render, staticRenderFns } from "./TabAccionistas.vue?vue&type=template&id=981f4cb8&scoped=true"
import script from "./TabAccionistas.vue?vue&type=script&lang=js"
export * from "./TabAccionistas.vue?vue&type=script&lang=js"
import style0 from "./TabAccionistas.vue?vue&type=style&index=0&id=981f4cb8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981f4cb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('981f4cb8')) {
      api.createRecord('981f4cb8', component.options)
    } else {
      api.reload('981f4cb8', component.options)
    }
    module.hot.accept("./TabAccionistas.vue?vue&type=template&id=981f4cb8&scoped=true", function () {
      api.rerender('981f4cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabAccionistas.vue"
export default component.exports